import { TextField } from '@mui/material';
import { ContactFields } from '../../components/ContactFields';
import { FormDialog } from '../../components/FormDialog';
import { FormField } from '../../components/FormField';
import { slug } from '../../lib/text';
import { addedText } from '../claudeTasks/useVaultRecords';
import { useAddForm } from '../../lib/useAddForm';
import type { Customer } from './sample';

const blank = {
  name: '',
  country: 'Jordan',
  city: '',
  contact: '',
  phone: '',
  email: '',
  industry: '',
  terms: '30 Days',
  clearanceBroker: '',
  clearanceBrokerCustomsId: '',
  taxId: '',
};
const TERMS = ['Cash', '15 Days', '30 Days', '45 Days', '60 Days'];

/** A form for a new customer. It goes to Claude, who writes it into the vault. */
export function AddCustomerDialog({
  open,
  onClose,
  onAdd,
}: {
  open: boolean;
  onClose: () => void;
  onAdd: (c: Customer) => void | Promise<unknown>;
}) {
  const { form, set, save, busy } = useAddForm(
    blank,
    (f): Customer => ({
      ...f,
      id: slug(f.name),
      address: '',
      website: '',
      status: 'Active',
      addedDaysAgo: 0,
      notes: '',
    }),
    onAdd,
    onClose,
    addedText('Customer'),
  );
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title="Add a customer"
      saveLabel="Add customer"
      canSave={Boolean(form.name.trim()) && !busy}
      onSave={save}
    >
      <ContactFields value={form} onChange={set} />
      <TextField label="Industry" value={form.industry} onChange={(e) => set({ industry: e.target.value })} />
      <FormField label="Payment terms" value={form.terms} onChange={(terms) => set({ terms })} options={TERMS} />
      <TextField
        label="Preferred clearance broker"
        value={form.clearanceBroker}
        onChange={(e) => set({ clearanceBroker: e.target.value })}
      />
      <TextField
        label="Clearance broker's customs ID"
        value={form.clearanceBrokerCustomsId}
        onChange={(e) => set({ clearanceBrokerCustomsId: e.target.value })}
      />
      <TextField label="Customer tax ID" value={form.taxId} onChange={(e) => set({ taxId: e.target.value })} />
    </FormDialog>
  );
}
